import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ShieldWithUserIcon = ({
  width = "12",
  height = "12",
  color = "#0860A8",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 8.5C8.70833 8.5 8.8855 8.42717 9.0315 8.2815C9.1775 8.13583 9.25033 7.95867 9.25 7.75C9.24967 7.54133 9.17683 7.36433 9.0315 7.219C8.88617 7.07367 8.709 7.00067 8.5 7C8.291 6.99933 8.114 7.07233 7.969 7.219C7.824 7.36567 7.751 7.54267 7.75 7.75C7.749 7.95733 7.822 8.1345 7.969 8.2815C8.116 8.4285 8.293 8.50133 8.5 8.5ZM8.5 10C8.75833 10 8.99583 9.9395 9.2125 9.8185C9.42917 9.6975 9.60417 9.53717 9.7375 9.3375C9.55417 9.22917 9.35833 9.14583 9.15 9.0875C8.94167 9.02917 8.725 9 8.5 9C8.275 9 8.05833 9.02917 7.85 9.0875C7.64167 9.14583 7.44583 9.22917 7.2625 9.3375C7.39583 9.5375 7.57083 9.698 7.7875 9.819C8.00417 9.94 8.24167 10.0003 8.5 10ZM6 11C4.84167 10.7083 3.88533 10.0437 3.131 9.006C2.37667 7.96833 1.99967 6.81633 2 5.55V2.5L6 1L10 2.5V5.3375C9.84167 5.27083 9.67917 5.21033 9.5125 5.156C9.34583 5.10167 9.175 5.06233 9 5.038V3.2L6 2.075L3 3.2V5.55C3 5.94167 3.05217 6.33333 3.1565 6.725C3.26083 7.11667 3.40667 7.48967 3.594 7.844C3.78133 8.19833 4.00833 8.52533 4.275 8.825C4.54167 9.12467 4.8375 9.37467 5.1625 9.575C5.25417 9.84167 5.375 10.0958 5.525 10.3375C5.675 10.5792 5.84583 10.7958 6.0375 10.9875C6.02917 10.9875 6.023 10.9897 6.019 10.994C6.015 10.9983 6.00867 11.0003 6 11ZM8.5 11C7.80833 11 7.21883 10.7562 6.7315 10.2685C6.24417 9.78083 6.00033 9.19133 6 8.5C5.99967 7.80867 6.2435 7.21917 6.7315 6.7315C7.2195 6.24383 7.809 6 8.5 6C9.191 6 9.78067 6.24383 10.269 6.7315C10.7573 7.21917 11.001 7.80867 11 8.5C10.999 9.19133 10.7552 9.781 10.2685 10.269C9.78183 10.757 9.19233 11.0007 8.5 11Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
